import { useState, useEffect } from 'react'
import { api } from '../lib/api.js'
import { UrsLogo } from '../components/UrsLogo.jsx'

export default function Login({ onLogin, onSwitchToRegister }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [registrationAllowed, setRegistrationAllowed] = useState(false)

  useEffect(() => {
    api.registrationStatus().then(s => setRegistrationAllowed(s.allowed)).catch(() => {})
  }, [])

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const result = await api.login(username.trim() || null, password || '')
      onLogin(result.token)
    } catch (err) {
      setError(err.message || 'Anmeldung fehlgeschlagen')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 28, color: 'var(--color-text)' }}>
          <UrsLogo width={92} />
        </div>

        <input
          type="text"
          className="input"
          placeholder="Benutzername oder Email"
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoFocus
          autoComplete="username"
        />

        <input
          type="password"
          className="input"
          placeholder="Passwort"
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="current-password"
        />

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? <span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} /> : 'Anmelden'}
        </button>

        {error && <p className="login-error">{error}</p>}

        {registrationAllowed ? (
          <p style={{ fontSize: '12px', color: 'var(--color-text-muted)', marginTop: '16px', textAlign: 'center' }}>
            Noch kein Konto?{' '}
            <a
              href="#"
              onClick={e => { e.preventDefault(); onSwitchToRegister?.() }}
              style={{ color: 'var(--color-primary)' }}
            >Konto erstellen</a>
          </p>
        ) : (
          <p style={{ fontSize: '12px', color: 'var(--color-text-muted)', marginTop: '16px' }}>
            Beim ersten Login wird das Passwort gesetzt.
          </p>
        )}
      </form>
    </div>
  )
}
